<template>
  <v-app>
    <v-main>
      <!-- <v-container -->
      <!-- fluid -->
      <!-- > -->
      <!-- <div class="container verticalLayout"> -->
      <!-- <div class="maxWidth"> -->

      <router-view
        v-slot="{ Component }"
        :key="$route.fullPath"
      >
        <component :is="Component" />
      </router-view>
      <!-- </div> -->
      <!-- </div> -->
      <!-- </v-container> -->
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
</script>
